export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";
export const GET_NEW_NOTIFICATION = "GET_NEW_NOTIFICATION";
export const SET_NOTIFICATIONS_PARAMS = "SET_NOTIFICATIONS_PARAMS";
